import { saveError, saveSuccess } from 'actions/form.base.actions';
import { createContent, updateContent } from 'services/api/content_requests';
import { imageValidations } from 'services/validations/image';

const canHandleAction = (action) => {
  if (action.type !== 'CREATE_FORM' && action.type !== 'UPDATE_FORM') {
    return false;
  }
  return (action.form.itemType === 'Image');
};

export const saveImageMiddleware = ({ dispatch, getState }) => next => action => {
  // Go to the next action if we're not saving or we're not a image
  if (!canHandleAction(action)) {
    return next(action)
  }

  const state = getState();

  let image_signed_id = state.form.values.image_file.signed_id;
  let image_body = {
    ...state.form.values,
    image_file: image_signed_id
  }

  const body = {
    image: image_body,
    tag_ids: state.form.tagIds || [],
    new_tag_names: state.form.newTagNames || []
  }

  let request;
  if (action.type === 'CREATE_FORM') {
    request = createContent(state.technique.id, state.form.categoryToAddItemTo.id, 'images', body)
  } else if (action.type === 'UPDATE_FORM') {
    request = updateContent(state.technique.id, state.form.selectedCategoryId, 'images', state.form.selectedElementId, body)
  }

  request
    .then(res => res.json())
    .then(res => dispatch(saveSuccess(res)))
    .catch(err => dispatch(saveError(err)));
};

export const imageFormValidationMiddleware = ({ dispatch, getState }) => next => action => {
  // Go to the next action if we're not saving or we're not a image
  if (!canHandleAction(action)) {
    return next(action)
  }

  const image = action.form;

  let errors = { ...imageValidations(image.values) }
  const anyErrors = Object.values(errors).some(errs => errs.length > 0);

  if (anyErrors) {
    dispatch(saveError(errors))
  } else {
    return next(action)
  }
};